import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { Flex, Icon, Link, Text, Tooltip } from "@driftt/dds"
import { faHorizontalRule } from '@driftt/dds.icons/regular/faHorizontalRule'

import useSalesforceData from "hooks/useSalesforceData"
import { AccountActivity, FormatLastTouched } from "modules/accountActivity/domain"
import { formatLastTouched } from "utils/activity"
import { haveTimePassed, timeSinceUpdated } from "utils/timeStamp"
import { segmentTrack,TrackType } from 'utils/tracking'


const LastTouch = ({ accountActivity }: { accountActivity: AccountActivity }) => {
    const { icon, sender, actionType, action, recipient, union, showBlank } = formatLastTouched(
      accountActivity?.driftSfdcTask ?? null
    ) as FormatLastTouched
    const salesforceData = useSalesforceData(accountActivity.companyData)
  
    if (showBlank) {
      return <Icon css={{ paddingLeft: '5px' }} icon={faHorizontalRule} size="medium" />
    }
  
    if (!accountActivity?.driftSfdcTask) {
      return null
    }
  
    if (haveTimePassed(accountActivity?.driftSfdcTask?.activityAt, 2, 'weeks')) {
      return <Icon css={{ paddingLeft: '5px' }} icon={faHorizontalRule} size="medium" />
    }
  
    return (
      <Flex alignItems="center" justifyContent="space-between" fullWidth>
        <Flex alignItems="center" gap="half">
          <Icon icon={icon} size="medium" />
          <Text css={{ minWidth: 'max-content' }} variant="body">
            {sender}
          </Text>
          <Text css={{ minWidth: 'max-content' }} variant="body">
            {action}
          </Text>
          {salesforceData?.baseUrl ? (
            <Link
              external
              onClick={() => segmentTrack(TrackType.LAST_TOUCH_NAVIGATES_TO_SALESFORCE)}
              truncate
              href={`${salesforceData?.baseUrl}lightning/r/Task/${accountActivity?.driftSfdcTask?.taskId}/view`}>
              <Flex alignItems="center">
                <Text variant="body" css={{ textDecoration: 'underline', color: '$gray8' }}>
                  {actionType}
                </Text>
              </Flex>
            </Link>
          ) : (
            <Text variant="body" css={{ color: '$gray8' }}>
              {actionType}
            </Text>
          )}
          <Text variant="body">{union}</Text>
          <Tooltip content={recipient}>
            {accountActivity?.driftSfdcTask?.buyer?.endUserId ? (
              <Link
                as={RouterLink}
                onClick={() => segmentTrack(TrackType.LAST_TOUCH_NAVIGATES_TO_CONTACT_DETAILS)}
                css={{
                  maxWidth: '165px',
                  textOverflow: 'ellipsis'
                }}
                variant="inline"
                truncate
                to={`/activity/contacts/${accountActivity?.driftSfdcTask?.buyer?.endUserId}`}
                target="_blank">
                {recipient}
              </Link>
            ) : (
              <Text
                truncate
                css={{
                  maxWidth: '165px',
                  textOverflow: 'ellipsis'
                }}>
                {recipient}
              </Text>
            )}
          </Tooltip>
        </Flex>
        <Text css={{ minWidth: '$8' }} variant="body">
          {timeSinceUpdated(accountActivity?.driftSfdcTask?.activityAt)} ago
        </Text>
      </Flex>
    )
  }
  
  export default LastTouch